<template>
    <div>
        <p class="heading">Customer Sentiments</p>
        <ThinPie :rawData="chartData" v-if="chartData.length" />
        <button v-if="navigation" class="section-button w-100 mt-4" @click="$emit('navigate-to-sentiment-details')">More
            Details</button>
    </div>
</template>
<script>
import ThinPie from '../../commonCharts/ThinPie.vue';

export default {
    name: "Sentiments",
    components: {
        ThinPie
    },
    data() {
        return {
            chartData: []
        }
    },
    props: {
        sentimentsData: {
            type: Object,
            required: true
        },
        navigation: Boolean
    },
    watch: {
        sentimentsData: {
            handler() {
                this.plotChart()
            },
            deep: true
        }
    },
    mounted() {
        this.plotChart();
    },
    methods: {
        plotChart() {
            this.chartData = [{
                name: 'Sentiments',
                colorByPoint: true,
                data: [{
                    name: 'Positive Sentiments',
                    y: this.sentimentsData.positive,
                    color: '#065559'
                }, {
                    name: 'Negative Sentiments',
                    y: this.sentimentsData.negative,
                    color: '#9B1C1C'
                }]
            }]
        }
    }

}
</script>
<style>
.section-button {
    padding: 8px 16px;
    border-radius: 8px;
    border: 1px solid #065559;
    background-color: transparent;
    font-size: 14px;
    font-weight: 400;
    line-height: 19.04px;
    color: #00555A;
}
</style>